// finlytics-frontend/src/pages/DashboardsPage.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';

const DashboardsPage = () => {
    const navigate = useNavigate();

    return (
        <div style={{ minHeight: '100vh', background: '#0a0f1a', padding: '32px 24px' }}>
            <button
                type="button"
                onClick={() => navigate('/home')}
                style={{
                    marginBottom: 16,
                    background: 'transparent',
                    border: '1px solid #1e2a42',
                    color: '#e1e7ef',
                    borderRadius: 6,
                    padding: '6px 12px',
                    cursor: 'pointer',
                    fontWeight: 600,
                    fontSize: 13,
                }}
            >
                ← Home
            </button>
            {/* Page Header */}
            <div style={{ marginBottom: 32 }}>
                <h1 style={{ color: '#f59e0b', fontSize: 28, fontWeight: 700, margin: 0, letterSpacing: 1 }}>
                    DASHBOARDS
                </h1>
                <p style={{ color: '#6b7280', fontSize: 14, marginTop: 6 }}>
                    Live macro &amp; geopolitical dashboards — updated from real-time data feeds
                </p>
            </div>

            {/* Dashboard Cards Grid */}
            <div
                style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))',
                    gap: 24,
                }}
            >
                {/* Hormuz Watch Card */}
                <div
                    role="button"
                    tabIndex={0}
                    onClick={() => navigate('/dashboards/hormuz')}
                    onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') navigate('/dashboards/hormuz'); }}
                    style={{
                        background: '#111827',
                        borderRadius: 8,
                        borderTop: '4px solid #f59e0b',
                        padding: '24px 20px',
                        cursor: 'pointer',
                        transition: 'transform 0.15s ease, box-shadow 0.15s ease',
                        outline: 'none',
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'translateY(-2px)';
                        e.currentTarget.style.boxShadow = '0 8px 32px rgba(245, 158, 11, 0.15)';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = 'none';
                    }}
                >
                    {/* Card Header Row */}
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
                        <h2 style={{ color: '#f9fafb', fontSize: 20, fontWeight: 700, margin: 0 }}>
                            Hormuz Watch
                        </h2>
                        {/* Pulsing LIVE Badge */}
                        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                            <span
                                style={{
                                    display: 'inline-block',
                                    width: 8,
                                    height: 8,
                                    borderRadius: '50%',
                                    background: '#ef4444',
                                    animation: 'pulse-dot 1.4s ease-in-out infinite',
                                }}
                            />
                            <span style={{ color: '#f59e0b', fontSize: 12, fontWeight: 700, letterSpacing: 1 }}>
                                LIVE
                            </span>
                        </div>
                    </div>

                    {/* Tagline */}
                    <p style={{ color: '#9ca3af', fontSize: 13, margin: '0 0 12px 0' }}>
                        Iran–US Conflict · Strait of Hormuz · Energy Crisis
                    </p>

                    {/* Description */}
                    <p style={{ color: '#d1d5db', fontSize: 14, lineHeight: 1.6, margin: '0 0 16px 0' }}>
                        Tracks Brent crude prices, Strait of Hormuz tanker traffic disruption,
                        and the Iran–US war events timeline.
                    </p>

                    {/* Stat Chips */}
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                        {[
                            { label: 'Brent $114.88', color: '#f59e0b' },
                            { label: 'Traffic ↓96%', color: '#ef4444' },
                            { label: '26 Events', color: '#a855f7' },
                        ].map((chip) => (
                            <span
                                key={chip.label}
                                style={{
                                    display: 'inline-block',
                                    background: `${chip.color}22`,
                                    color: chip.color,
                                    border: `1px solid ${chip.color}55`,
                                    borderRadius: 4,
                                    padding: '3px 10px',
                                    fontSize: 12,
                                    fontWeight: 600,
                                }}
                            >
                                {chip.label}
                            </span>
                        ))}
                    </div>
                </div>
                {/* India DC Tracker Card */}
                <div
                    role="button"
                    tabIndex={0}
                    onClick={() => navigate('/dashboards/dc-tracker')}
                    onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') navigate('/dashboards/dc-tracker'); }}
                    style={{
                        background: '#111827',
                        borderRadius: 8,
                        borderTop: '4px solid #22c55e',
                        padding: '24px 20px',
                        cursor: 'pointer',
                        transition: 'transform 0.15s ease, box-shadow 0.15s ease',
                        outline: 'none',
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'translateY(-2px)';
                        e.currentTarget.style.boxShadow = '0 8px 32px rgba(34, 197, 94, 0.15)';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = 'none';
                    }}
                >
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
                        <h2 style={{ color: '#f9fafb', fontSize: 20, fontWeight: 700, margin: 0 }}>
                            India DC Tracker
                        </h2>
                        <span style={{ color: '#22c55e', fontSize: 12, fontWeight: 700, letterSpacing: 1 }}>
                            9 STOCKS
                        </span>
                    </div>
                    <p style={{ color: '#9ca3af', fontSize: 13, margin: '0 0 12px 0' }}>
                        Data Centre Buildout · Hyperscaler Deals · MW Capacity
                    </p>
                    <p style={{ color: '#d1d5db', fontSize: 14, lineHeight: 1.6, margin: '0 0 16px 0' }}>
                        Tracks 9 Indian-listed stocks building data centres — MW capacity, capex,
                        hyperscaler customers, solar PPAs, and valuation multiples.
                    </p>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                        {[
                            { label: 'Real Estate', color: '#f59e0b' },
                            { label: 'Telecom', color: '#3b82f6' },
                            { label: 'IT / Hardware', color: '#a855f7' },
                        ].map((chip) => (
                            <span
                                key={chip.label}
                                style={{
                                    display: 'inline-block',
                                    background: `${chip.color}22`,
                                    color: chip.color,
                                    border: `1px solid ${chip.color}55`,
                                    borderRadius: 4,
                                    padding: '3px 10px',
                                    fontSize: 12,
                                    fontWeight: 600,
                                }}
                            >
                                {chip.label}
                            </span>
                        ))}
                    </div>
                </div>

                {/* BankLens Card */}
                <div
                    role="button"
                    tabIndex={0}
                    onClick={() => navigate('/dashboards/bank-lens')}
                    onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') navigate('/dashboards/bank-lens'); }}
                    style={{
                        background: '#111827',
                        borderRadius: 8,
                        borderTop: '4px solid #20b072',
                        padding: '24px 20px',
                        cursor: 'pointer',
                        transition: 'transform 0.15s ease, box-shadow 0.15s ease',
                        outline: 'none',
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'translateY(-2px)';
                        e.currentTarget.style.boxShadow = '0 8px 32px rgba(32, 176, 114, 0.15)';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = 'none';
                    }}
                >
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
                        <h2 style={{ color: '#f9fafb', fontSize: 20, fontWeight: 700, margin: 0 }}>
                            BankLens
                        </h2>
                        <span style={{ color: '#20b072', fontSize: 12, fontWeight: 700, letterSpacing: 1 }}>
                            9 BANKS
                        </span>
                    </div>
                    <p style={{ color: '#9ca3af', fontSize: 13, margin: '0 0 12px 0' }}>
                        India Banking Dashboard · NPA · Capital · Profitability
                    </p>
                    <p style={{ color: '#d1d5db', fontSize: 14, lineHeight: 1.6, margin: '0 0 16px 0' }}>
                        Deep-dive into 9 Indian banks — 10-year financial metrics, asset quality trends,
                        capital adequacy, liquidity health, and side-by-side comparisons.
                    </p>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                        {[
                            { label: 'Private Banks', color: '#20b072' },
                            { label: 'PSU Banks', color: '#38bdf8' },
                            { label: 'FY2016–Q3 FY26', color: '#f59e0b' },
                        ].map((chip) => (
                            <span
                                key={chip.label}
                                style={{
                                    display: 'inline-block',
                                    background: `${chip.color}22`,
                                    color: chip.color,
                                    border: `1px solid ${chip.color}55`,
                                    borderRadius: 4,
                                    padding: '3px 10px',
                                    fontSize: 12,
                                    fontWeight: 600,
                                }}
                            >
                                {chip.label}
                            </span>
                        ))}
                    </div>
                </div>
            </div>

            {/* Pulse animation keyframes injected inline */}
            <style>{`
                @keyframes pulse-dot {
                    0%, 100% { opacity: 1; transform: scale(1); }
                    50% { opacity: 0.4; transform: scale(1.3); }
                }
            `}</style>
        </div>
    );
};

export default DashboardsPage;
